import type { IToken } from 'chevrotain';

import { numericSort } from 'bones/utils/sort/numericSort';

export const tokenSort = numericSort((token: IToken) => token.startOffset);
